/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

import AuthService from 'cio/services/auth';
import { ComponentLike } from '@glint/template';

interface DetailEditorArgs {
  name: string;
  errors: any;
  tagEditorComponent: ComponentLike<any>;
  onClose: () => void;
  onSave: (options: { name: string }) => void;
}

export default class DetailEditor extends Component<DetailEditorArgs> {
  @service auth!: AuthService;

  @tracked isEditing = false;
  @tracked editedName = '';

  saveTask = task(async (event: Event) => {
    event.preventDefault();

    await this.args.onSave({ name: this.editedName });
    this.isEditing = false;
  });

  @action
  edit() {
    this.editedName = this.args.name;

    this.isEditing = true;
  }

  @action
  cancel() {
    this.isEditing = false;
    this.args.onClose();
  }
}
